import { Box, Menu } from "@mui/material";
import { ChromePicker } from "react-color";
import { useState } from "react";
import { useEffect } from "react";
import ColorizeOutlinedIcon from "@mui/icons-material/ColorizeOutlined";

const ColorPicker = ({ setColor, title, defaultColor, pickerColor = "text-white" }) => {
    const [themeAnchor, setThemeAnchor] = useState(null);
    const [showColorPicker, setShowColorPicker] = useState(false);
    const [themeColor, setThemeColor] = useState(defaultColor);

    const handleAnchor = (event) => {
        setThemeAnchor(event.currentTarget);
        setShowColorPicker((show) => !show);
    };

    useEffect(() => {
        if (setColor) {
            setColor(themeColor);
        }
    }, [themeColor]);

    useEffect(() => {
        setThemeColor(defaultColor);
    }, [defaultColor]);

    return (
        <Box>
            <div className="text-[#3D4A5C] font-semibold leading-[21px] mb-[7px]">{title}</div>
            <Box display="flex">
                <input
                    onChange={(e) => setThemeColor((theme) => e.target.value)}
                    value={themeColor}
                    type="text"
                    placeholder="color e.g. #444"
                    className="mr-[14px] text-[#8897AE] w-[121px] rounded-md text-[14px] outline-none py-[10.29px] px-[12.5px] border border-slate-300"
                />

                <Box
                    onClick={handleAnchor}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    className="rounded-full"
                    sx={{
                        border: ".89px solid #D7DFE9",
                        backgroundColor: themeColor,
                        width: 45,
                        cursor: "pointer",
                    }}
                >
                    <ColorizeOutlinedIcon className={pickerColor}></ColorizeOutlinedIcon>
                </Box>
            </Box>

            <Box position="absolute" top="100%" right={0} zIndex={100}>
                <Menu
                    elevation={0}
                    anchorEl={themeAnchor}
                    id="basic-menu"
                    open={showColorPicker}
                    onClose={handleAnchor}
                    MenuListProps={{
                        "aria-labelledby": "basic-button",
                    }}
                >
                    <ChromePicker color={themeColor} onChangeComplete={(e) => setThemeColor((themeColors) => e.hex)} />
                </Menu>
            </Box>
        </Box>
    );
};

export default ColorPicker;
